export const staffList = (state) => state.staffs;
export const menuList = (state) => state.menus.all;
export const treeData = (state) => state.tree.all;



// WEBPACK FOOTER //
// ./E:/vue/bh-vue-demo/src/vuex/getters.js